import { useMemo, type ReactNode } from 'react';
import SettingsContext, { type SettingsContextType } from './SettingsContext';
import useStorageSettings from './useStorageSettings';

function SettingsProvider({ children }: { children: ReactNode }) {
  const [settings, update] = useStorageSettings();
  const value = useMemo(() => ({
    ...settings,
    update,
  }), [settings, update]) as SettingsContextType;
  return (
    <SettingsContext value={value}>
      {children}
    </SettingsContext>
  );
}

export default SettingsProvider;
